import { getLink } from "@utils/linkUtils";
import classNames from "classnames";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";

import { ctaClickTracking } from "@/dataLayer/dataLayer";
import { DL_KEYS } from "@/dataLayer/keys";
import { CompactModal as CompactModalType, ImageElement } from "@/types";

import RichText from "../RichText/RichText";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";
import Icon from "../ui/Icon/Icon";
import Modal from "../ui/Modal/Modal";

export const CompactModal: React.FC<CompactModalType> = ({ title, image, bodyTitle, bodySubtitle, bodyText, onClose, cta }) => {
  const t = useTranslations();
  const locale = useLocale();
  return (
    <Modal
      open={true}
      onClose={() => {
        if (onClose) {
          onClose();
        }
      }}
      className="w-100 modal regular-modal"
    >
      <div className="modal__content bg-white max-md:w-full md:rounded-2xl md:max-h-[643px] flex flex-col h-screen">
        <span className="modal__top-label font-primary flex justify-between items-center p-l uppercase font-medium">
          {title}
          <Button
            className="modal__close"
            size={ButtonSize.MEDIUM}
            variant={ButtonVariant.TERTIARY}
            theme={ButtonTheme.BLACK}
            onClick={() => {
              if (onClose) {
                onClose();
              }
              // ctaClickTracking(t("button.label.close"), "CompactModal", "CompactModal");
              ctaClickTracking(DL_KEYS?.close, "CompactModal", "CompactModal");
            }}
            tabIndex={0}
          >
            <span className="pointer-events-none">
              <Icon name="close" size="24" title="close" className="stroke-black" />
              <span className="sr-only">{t("button.label.close")}</span>
            </span>
          </Button>
        </span>
        <div className={classNames("modal__content-wrapper overflow-y-auto pb-l px-l")}>
          <div className="w-100 md:max-w-[630px]">
            <Image
              src={image.url}
              width={600}
              height={307}
              alt={image.title || ""}
              className="mx-auto w-full h-[307px] object-cover"
              objectFit="cover"
            />
            <p className="font-primary uppercase mt-l mb-m text-l font-medium">{bodyTitle}</p>
            {bodySubtitle && <p className="font-primary text-s pb-l uppercase font-normal">{bodySubtitle}</p>}
            <p className="font-secondary-light text-s leading-5 mb-m">
              <RichText content={{ html: bodyText }} />
            </p>
            {cta && (
              <Link
                href={getLink(cta?.link?.url, locale)}
                className="pb-xl md:pb-xs hover:text-gold font-primary text-s underline underline-offset-4 uppercase font-medium"
              >
                {cta.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
